// extracted by mini-css-extract-plugin
module.exports = {"container":"pdfViewer_container__XlVfO","infoIcon":"pdfViewer_infoIcon__2WueI"};